module.exports = __webpack_public_path__ + "static/media/path.d11aeb7b.jpg";